// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddVideoBlock_wrapper__26yOb","text":"AddVideoBlock_text__2CYiu","addBtnWrapper":"AddVideoBlock_addBtnWrapper__VC_rh","disabled":"AddVideoBlock_disabled__1YQ3D"};